import React, { useState } from "react";
import {
  Button,
  Checkbox,
  CustomSelect,
  Divider,
  FormFieldSet,
  InfoTimeCard,
  TableAdv,
  PageHeader,
  PageTitle,
  Tag,
  useFormHandler,
} from "../../../../../components";
import { paymentrowData } from "../../../../../assets/data/candidatesData";
import { mapTableRows } from "../../../../../utils";
import BankInformationModal from "./Models/bankinformationModal";
import {
  AccountpayableAccountType,
  Accountpayablepaytype,
} from "../../../../../assets/data/projectData";

const EditPayment = ({ onBack, rowData }) => {
  const [model, setmodel] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const tablerowData = paymentrowData;

  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Vendor: rowData?.Vendor || "",
    PaymentDate: rowData?.PaymentDate || "",
    PaymentType: rowData?.PaymentType || "",
    AccountType: rowData?.AccountType || "",
    ReferenceNumber: rowData?.ReferenceNumber || "",
    Notes: rowData?.Note || "",
    PaidAmount: rowData?.PaidAmount || "",
  });

  const AllbillsColumns = [
    { key: "Description", label: "Description" },
    { key: "DueDate", label: "Due Date" },
    { key: "OriginalAmount", label: " Original Amount" },
    { key: "PaymentReceived", label: " Payment Received" },
    { key: "OpenBalance", label: "Open Balance" },
    { key: "EnterPaymentAmount", label: "Enter Payment Amount" },
    { key: "PaymentDiscount", label: " Payment Discount" },
    {
      key: "action",
      label: "",
      render: (row) => (
        <CustomSelect
          type="select"
          title=""
          placeholder="Discount"
          value={formData.Discount}
          onChange={(value) => handleChange("Discount", value)}
          error={errors.Discount}
          size="xs"
        />
      ),
      sortable: false,
    },
  ];
  // Add id field to each row for TableAdv
    const dataWithIds = tablerowData.map((item, index) => ({
      ...item,
      id: item.id || index, // Ensure each row has an id
    }));
  
    const mappedRows = mapTableRows(dataWithIds, AllbillsColumns);

  const handleViewBankDetails = () => {
    setmodel(!model);
  };
  const handleClear = () => {
    console.log("i am clicked");
  };
  // Handle selection change from TableAdv
  const handleSelectionChange = (selectedRowIds) => {
    console.log("Selected row IDs:", selectedRowIds);
    setSelectedRows(selectedRowIds);

    // Find the actual row objects from mappedRows
    const selectedRowObjects = mappedRows.filter((row) =>
      selectedRowIds.includes(row.id)
    );

    console.log("Selected row objects:", selectedRowObjects);
  };
  return (
    <div className="px-2 py-2 w-full">
      <div>
        <PageHeader
          Section={
            <div className="flex gap-3">
              <PageTitle title={"Edit Vendor Payment"} tag="h5" size={"sm"} />
              <Tag
                title="Tektree"
                variant="outlined"
                className=" !text-neutrals !py-1.5"
              />
            </div>
          }
          RightSection={
            <div className="flex gap-3">
              <Button
                size="sm"
                title={"Back"}
                icon={"arrow_left_alt"}
                onClick={onBack}
              />
            </div>
          }
        />
      </div>
      <div className="grid grid-cols-3 xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
        <FormFieldSet
          type="select"
          title="Vendor"
          placeholder=" select Vendor"
          value={formData.Vendor}
          onChange={(value) => handleChange("Vendor", value)}
          error={errors.Vendor}
        />
        <div className="mt-5">
          <Button title={"View Bank Details"} onClick={handleViewBankDetails} />
        </div>
        <div className="hidden xl:block" />
        <div className="mr-10 mt-5">
          <InfoTimeCard
            title="Paid Amount"
            color="primary"
            value={formData.PaidAmount}
            suffix={"USD"}
            type2
          />
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
        <FormFieldSet
          type="text"
          title="Payment Date"
          placeholder=" Enter Payment Date"
          value={formData.PaymentDate}
          onChange={(value) => handleChange("PaymentDate", value)}
          error={errors.PaymentDate}
        />
        <FormFieldSet
          type="select"
          title="Payment Type"
          placeholder=" select Payment Type"
          value={formData.PaymentMethod}
          onChange={(value) => handleChange("PaymentMethod", value)}
          error={errors.PaymentMethod}
          options={Accountpayablepaytype}
        />
        <FormFieldSet
          type="select"
          title="Account Type"
          placeholder=" select AccountType"
          value={formData.AccountType}
          onChange={(value) => handleChange("AccountType", value)}
          error={errors.AccountType}
          options={AccountpayableAccountType}
        />
        <FormFieldSet
          type="text"
          title="Reference Number"
          placeholder=" Enter Reference Number"
          value={formData.ReferenceNumber}
          onChange={(value) => handleChange("ReferenceNumber", value)}
          error={errors.ReferenceNumber}
        />
        <FormFieldSet
          type="textArea"
          title="Notes"
          placeholder=" Enter Notes"
          value={formData.Notes}
          onChange={(value) => handleChange("Notes", value)}
          error={errors.Notes}
        />
        <FormFieldSet
          type="text"
          title=" Paid Amount"
          placeholder=" Enter  Paid Amount"
          value={formData.PaidAmount}
          onChange={(value) => handleChange("PaidAmount", value)}
          error={errors.PaidAmount}
        />
      </div>
      <div className="flex justify-end">
        <Button size="md" title={"Clear Payment"} onClick={handleClear} />
      </div>
      <div className="flex-1 flex overflow-hidden mt-4">
        <TableAdv
          tableId={`accountspayable_payments_editpayment`}
          showCheckbox
          columns={AllbillsColumns}
          rows={mappedRows}
          onSelectionChange={handleSelectionChange}
          defaultSelectedRows={selectedRows}
          toolbarRight={{
            filter: false,
            search: true,
          }}
        />
      </div>
      <div className="flex items-center justify-between mt-5">
        <p> ACTIVITIES</p>
        <Button
          size="sm"
          title={"Add"}
          onClick={""}
          color="black"
          icon={"add"}
        />
      </div>
      <div>
        <BankInformationModal open={model} onClose={() => setmodel(!model)} />
      </div>
      <Divider />
      <div className="flex gap-3 justify-end my-6">
        <Button title="Cancel" variant="outlined" onClick={""} />
        <Button title="Save" onClick={""} />
      </div>
    </div>
  );
};

export default EditPayment;
